import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import * as fromStore from '../../_store';
import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import { take } from 'rxjs/operators';
var INDRAPassengerDetailStudentComponent = /** @class */ (function () {
    function INDRAPassengerDetailStudentComponent(fb, store, globalStore) {
        this.fb = fb;
        this.store = store;
        this.globalStore = globalStore;
        this.displayValidationMessages = false;
        this.form = this.fb.group({
            studentDocNumber: [null, [Validators.required, Validators.pattern('[a-zA-Z0-9_]+')]],
            studentfiscalNumber: [null, [Validators.required, Validators.pattern('[a-zA-Z0-9_]+')]],
            student_confirm: [false, [Validators.requiredTrue]],
        });
        this.sub$ = new Subscription();
        this._hasChanges = new BehaviorSubject(false);
    }
    Object.defineProperty(INDRAPassengerDetailStudentComponent.prototype, "hasChanges", {
        get: function () {
            return this._hasChanges.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailStudentComponent.prototype, "hasErrorClassDocNum", {
        get: function () {
            return this.form.get('studentDocNumber').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailStudentComponent.prototype, "hasErrorClassFiscalNum", {
        get: function () {
            return this.form.get('studentfiscalNumber').invalid && this.form.touched && this.displayValidationMessages ? 'has-error' : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailStudentComponent.prototype, "hasData", {
        get: function () {
            return !_.isEmpty(this.form.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRAPassengerDetailStudentComponent.prototype, "hasErrors", {
        get: function () {
            return !_.isEmpty(this.form.errors);
        },
        enumerable: true,
        configurable: true
    });
    INDRAPassengerDetailStudentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub$.add(this.store.select(fromStore.getSelectedPassengersAtIndex)
            .subscribe(function (passenger) {
            if (passenger) {
                _this.mapPassengerToForm(passenger);
                // this.verifyFormValidations();
            }
        }));
        this.sub$.add(this.form.valueChanges.subscribe(function () { return _this._hasChanges.next(true); }));
        this.formValueChangesUpdateStudentInfo();
    };
    INDRAPassengerDetailStudentComponent.prototype.formValueChangesUpdateStudentInfo = function () {
        var _this = this;
        this.sub$.add(this.form.get('studentDocNumber').valueChanges.subscribe(function () { return _this.dispatchUpdateStudentInfo(); }));
        this.sub$.add(this.form.get('studentfiscalNumber').valueChanges.subscribe(function () { return _this.dispatchUpdateStudentInfo(); }));
        this.sub$.add(this.form.get('student_confirm').valueChanges.subscribe(function () { return _this.dispatchUpdateStudentInfo(); }));
        this.dispatchUpdateStudentInfo();
    };
    INDRAPassengerDetailStudentComponent.prototype.dispatchUpdateStudentInfo = function () {
        this.store.dispatch(new fromStore.UpdateFormChangedAction({ 'updateStudentInfo': true }));
    };
    INDRAPassengerDetailStudentComponent.prototype.mapPassengerToForm = function (data) {
        this.form.patchValue({
            studentDocNumber: data.studentDocNumber,
            studentfiscalNumber: data.studentfiscalNumber,
            student_confirm: false
        }, { emitEvent: false });
    };
    INDRAPassengerDetailStudentComponent.prototype.ngOnDestroy = function () {
        this.sub$.unsubscribe();
    };
    INDRAPassengerDetailStudentComponent.prototype.formStudentErrors = function (control) {
        var errors = [];
        if (Object.is('studentDocNumber', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.studentFareDocumentNumRequired');
            }
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.studentFareDocumentNumInvalid');
            }
        }
        if (Object.is('studentfiscalNumber', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.studentFareFiscalNumRequired');
            }
            if (this.form.controls[control].hasError('pattern')) {
                errors.push('bookingDetails.error.studentFareFiscalNumInvalid');
            }
        }
        if (Object.is('student_confirm', control)) {
            if (this.form.controls[control].hasError('required')) {
                errors.push('bookingDetails.error.studentFareConfirmationRequired');
            }
        }
        return errors.join('; ');
    };
    INDRAPassengerDetailStudentComponent.prototype.clearForm = function () {
        this.form.reset({ emitEvent: false });
    };
    INDRAPassengerDetailStudentComponent.prototype.cancelEdit = function () {
        var _this = this;
        this.store.select(fromStore.getSelectedPassengersAtIndex)
            .pipe(take(1)).subscribe(function (data) {
            _this.form.reset({
                studentDocNumber: data.studentDocNumber,
                studentfiscalNumber: data.studentfiscalNumber,
                student_confirm: false
            }, { emitEvent: false });
            _this._hasChanges.next(false);
        });
        this.store.dispatch(new fromStore.UpdateFormChangedAction({
            'updateStudentInfo': false,
        }));
    };
    return INDRAPassengerDetailStudentComponent;
}());
export { INDRAPassengerDetailStudentComponent };
